/** Case-insensitive substring filter for SelectInput option lists. */
export const filterBySearch = <T extends { label: string }>(options: T[], search: string): T[] =>
  search ? options.filter((o) => o.label.toLowerCase().includes(search.toLowerCase())) : options;

/** Moves currently-selected options to the top, preserving relative order. */
export const moveSelectedToTop = <T extends { value: string }>(
  options: T[],
  selectedValues: string[],
): T[] => {
  if (!Array.isArray(selectedValues) || selectedValues.length === 0) {
    return options;
  }
  const selectedSet = new Set(selectedValues);
  const selected = options.filter((o) => selectedSet.has(o.value));
  const rest = options.filter((o) => !selectedSet.has(o.value));
  return [...selected, ...rest];
};

/** Wraps a single selected policy id into the string[] shape moveSelectedToTop expects. */
export const toSelectedPolicyValues = (selectedPolicy: unknown): string[] =>
  selectedPolicy ? [String(selectedPolicy)] : [];
